module.exports = __webpack_public_path__ + "img/Home Improvements_Recall_3_Set.c7cc8f2e.png";